import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';

export const WarrantyImageWrapper = styled(Box)<{
  $height?: string;
  $width?: string;
}>`
  flex-shrink: 0;
  &&&& {
    svg {
      margin: 0;
      transform: scale(0.8);
    }
  }
  ${({ $height, $width, theme }) => css`
    width: ${$width ? $width : '102px'};
    height: ${$height ? $height : '102px'};
    ${theme.media.md.up} {
      width: ${$width ? $width : '108px'};
      height: ${$height ? $height : '108px'};
    }
  `}
`;
